(() => {
  const root = document.documentElement;
  if (!root.classList.contains('template-index-fullpage-snap')) return;

  /*
   * Retired behavior: homepage wheel/key hijacking.
   * Current rule: the opening hero is viewport-tall; all later sections and
   * footer scroll naturally for a calmer AELEIN editorial rhythm.
   */
})();
